<main class="relative flex flex-col pt-14 lg:pt-18 overflow-x-hidden">
  <div class="relative w-full">
    <img src="/event/top-bg-mo.svg" alt="top background" class="w-full flex lg:hidden" />
    <img src="/event/top-bg-pc.svg" alt="top background" class="w-full hidden lg:flex" />

    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-4">
      <p class="sb-aggro text-white/40 font-light text-xs">홈 > 관람 안내</p>
      <h1 class="text-white text-2xl lg:text-4xl">관람 안내</h1>
      <p class="text-zinc-400 font-medium">창업&프랜차이즈 박람회의 관람안내를 살펴보세요.</p>
    </div>
  </div>

  <!-- 전시/관람 및 비용 안내 섹션 -->
  <section class="flex flex-col w-full max-w-7xl mx-auto py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
    <div class="flex flex-col lg:flex-row gap-6 lg:gap-10">
      <div class="flex justify-start lg:min-w-[300px]">
        <h1 class="text-zinc-800 text-xl lg:text-3xl">전시/관람 및 비용 안내</h1>
      </div>

      <div class="flex flex-col gap-8 lg:gap-15 w-full">
        <!-- 전시 및 관람 -->
        <div class="flex flex-col gap-3 lg:gap-4 w-full">
          <h1 class="text-lg lg:text-xl text-zinc-800">전시 및 관람</h1>

          <!-- PC: 3 columns grid, Mobile: 세로 스택 -->
          <div class="flex flex-col lg:grid lg:grid-cols-3 gap-2 lg:gap-4">
            <!-- 명칭 -->
            <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-3 lg:min-h-90">
              <div class="bg-white rounded-sm h-full py-6 lg:pt-24 flex flex-col">
                <div class="flex lg:flex-col gap-4 lg:gap-4 items-center px-6 lg:px-0">
                  <img src="/registration/title.svg" alt="명칭 아이콘" class="size-12 lg:size-15" />
                  <div class="flex flex-col gap-2 items-start lg:items-center">
                    <p class="text-zinc-400 font-medium text-sm lg:text-base">명칭</p>
                    <p class="sb-aggro text-zinc-800 text-base lg:text-lg text-center">창업&프랜차이즈 박람회</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 관람기관 및 장소 -->
            <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-3 lg:min-h-90">
              <div class="bg-white rounded-sm h-full py-6 lg:pt-24 flex flex-col">
                <div class="flex lg:flex-col gap-4 lg:gap-4 items-center px-6 lg:px-0">
                  <img src="/registration/title.svg" alt="관람기관 아이콘" class="size-12 lg:size-15" />
                  <div class="flex flex-col gap-2 items-start lg:items-center">
                    <p class="text-zinc-400 font-medium text-sm lg:text-base">관람기관 및 장소</p>
                    <p class="sb-aggro text-zinc-800 text-base lg:text-lg">박람회 일정 참고</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 관람시간 -->
            <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-3 lg:min-h-90">
              <div class="bg-white rounded-sm h-full py-6 lg:pt-24 flex flex-col">
                <div class="flex lg:flex-col gap-4 lg:gap-4 items-start lg:items-center px-6 lg:px-0">
                  <img src="/registration/title.svg" alt="관람시간 아이콘" class="size-12 lg:size-15 shrink-0" />
                  <div class="flex flex-col gap-2 items-start lg:items-center w-full">
                    <p class="text-zinc-400 font-medium text-sm lg:text-base">관람시간</p>
                    <p class="sb-aggro text-zinc-800 text-base lg:text-lg">10:00~18:00</p>
                    <ul class="hidden lg:flex lg:flex-col list-disc list-inside text-zinc-400 text-xs space-y-1 px-4">
                      <li>첫날과 마지막 날은 조기 종료될 수 있습니다.</li>
                      <li>관람시간 종료 30분전까지만 입장이 가능합니다.</li>
                    </ul>
                  </div>
                </div>
                <ul class="flex flex-col lg:hidden list-disc list-inside text-zinc-400 text-xs space-y-1 px-8 pt-3">
                  <li>첫날과 마지막 날은 조기 종료될 수 있습니다.</li>
                  <li>관람시간 종료 30분전까지만 입장이 가능합니다.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 관람 비용 -->
        <div class="flex flex-col gap-4">
          <h1 class="text-lg lg:text-xl text-zinc-800">관람 비용</h1>
          <div class="flex flex-col gap-5 bg-zinc-50 rounded-2xl p-6 lg:p-8">
            <!-- 유료 -->
            <div class="flex gap-6 items-center">
              <div class="bg-primary-500 size-15 rounded-md justify-center flex items-center shrink-0">
                <p class="text-white sb-aggro text-sm font-light">유료</p>
              </div>
              <div class="flex flex-col gap-1">
                <p class="sb-aggro text-sm text-zinc-400 font-light">입장료</p>
                <p class="sb-aggro text-lg text-zinc-800">5,000원</p>
              </div>
            </div>

            <div class="w-full h-px bg-zinc-200"></div>

            <!-- 무료 -->
            <div class="flex flex-col lg:flex-row gap-4 lg:gap-10 w-full">
              <div class="flex gap-6 items-center shrink-0">
                <div class="bg-zinc-300 size-15 rounded-md justify-center flex items-center">
                  <p class="text-white sb-aggro text-sm font-light">무료</p>
                </div>
                <div class="flex flex-col gap-1 lg:w-20">
                  <p class="sb-aggro text-sm text-zinc-400 font-light">입장료</p>
                  <p class="sb-aggro text-lg text-zinc-800">무료</p>
                </div>
              </div>

              <ul
                class="pt-4 px-2 space-y-1 lg:pt-0 lg:px-0 flex items-center flex-wrap list-disc list-inside text-zinc-500 text-sm space-x-4">
                <li>초청 장소 소지자(등록카드 작성)</li>
                <li>경로우대증 소지자</li>
                <li>국가유공자</li>
                <li>65세 이상</li>
                <li>사전등록자(홈페이지 온라인 사전 등록자)</li>
                <li>초등학생 이하 어린이(보호자 동반시)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 유형별 관람객 절차 -->
  <section class="flex flex-col w-full bg-zinc-50 py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
    <div class="w-full max-w-7xl mx-auto">
      <div class="flex flex-col lg:flex-row gap-6 lg:gap-10 lg:h-200">
        <!-- 왼쪽: 고정 영역 (데스크톱에서만 sticky) -->
        <div class="flex flex-col gap-3 justify-start lg:min-w-[300px] lg:sticky lg:top-20 lg:self-start">
          <h1 class="text-zinc-800 text-xl lg:text-3xl">유형별 관람객 절차</h1>
          <p class="text-zinc-400 font-medium text-sm lg:text-base">
            현장등록, 온라인 관람객의 <br class="hidden lg:flex" />
            절차를 안내드립니다.
          </p>
        </div>

        <!-- 오른쪽: 스크롤 영역 (데스크톱에서만) -->
        <div class="flex flex-col w-full gap-8 lg:gap-15 lg:h-200 lg:overflow-y-auto lg:pr-4">
          <!-- 현장 등록 관람객 -->
          <div class="flex flex-col gap-4">
            <h1 class="text-lg lg:text-xl text-zinc-800 flex items-center gap-2">
              <span class="text-lg sb-aggro text-primary-500">01</span>현장등록 관람객
            </h1>
            <div class="flex flex-col lg:gap-1">
              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-1.svg" alt="step icon" class="size-8 lg:size-10" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 1</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">입장권 구매</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-2.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 2</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">전시장 입구 사전 등록대</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-3.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 3</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">설문지 작성</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-4.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 4</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">전시장 입구 출입증 발급대</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-5.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 5</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">초청장 및 설문지 제출</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-6.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 6</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">출입증 수정</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-7.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 7</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">입장</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 온라인 사전등록 관람객 -->
          <div class="flex flex-col gap-4">
            <h1 class="text-lg lg:text-xl text-zinc-800 flex items-center gap-2">
              <span class="text-lg sb-aggro text-primary-500">02</span>온라인 사전등록 관람객
            </h1>
            <div class="flex flex-col lg:gap-1">
              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-4.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 1</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">전시장 입구 출입증 발급대</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-2-2.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 2</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">사전등록 출력자료 제출 및 본인확인</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-6.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 3</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">출입증 수정</p>
                </div>
              </div>
              <app-icon name="solar:alt-arrow-down-bold" class="text-zinc-200 size-6! mx-auto" />

              <div class="flex gap-6 lg:gap-10 bg-zinc-100 rounded-2xl py-3 px-5 lg:p-8 items-center">
                <div class="w-10 lg:w-12 flex items-center justify-center shrink-0">
                  <img src="/registration/step-7.svg" alt="step icon" class="size-6 lg:size-7" />
                </div>
                <div class="flex flex-col gap-1 lg:gap-2.5">
                  <p class="text-zinc-400 lg:text-zinc-800 sb-aggro font-light text-xs lg:text-base">STEP 4</p>
                  <p class="text-zinc-800 sb-aggro text-sm lg:text-lg">입장</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
